// src\components\common\EmergencyAlert.jsx
import React from 'react';
import { AlertTriangle, X, PhoneCall, Clock } from 'lucide-react';

/**
 * Composant pour afficher une alerte d'urgence en cas de problème critique
 */
const EmergencyAlert = ({ alert, onClose }) => {
  if (!alert) return null;
  
  // Déterminer la couleur de fond en fonction du niveau de criticité
  const getBgColor = (level) => {
    switch(level) {
      case 'critical':
        return 'bg-red-100 border-red-500';
      case 'high':
        return 'bg-orange-100 border-orange-500';
      case 'medium':
        return 'bg-yellow-100 border-yellow-500';
      default:
        return 'bg-blue-100 border-blue-500';
    }
  };
  
  // Déterminer la couleur de texte en fonction du niveau de criticité
  const getTextColor = (level) => {
    switch(level) {
      case 'critical':
        return 'text-red-700';
      case 'high':
        return 'text-orange-700';
      case 'medium':
        return 'text-yellow-700';
      default:
        return 'text-blue-700';
    }
  };

  return (
    <div className={`fixed bottom-4 right-4 max-w-xl rounded-lg shadow-lg border-l-4 ${getBgColor(alert.level)}`}>
      <div className={`p-4 ${getTextColor(alert.level)}`}>
        <div className="flex justify-between items-start">
          <div className="flex">
            <AlertTriangle size={24} className="mt-0.5" />
            <div className="ml-3">
              <h3 className="text-lg font-bold">{alert.title}</h3>
              <p className="mt-1">{alert.message}</p>
              
              {/* Informations complémentaires */}
              <div className="grid grid-cols-2 gap-2 mt-3">
                {alert.resource && (
                  <div className="flex items-center">
                    <span className="font-medium mr-2">Moyen affecté:</span>
                    <span>{alert.resource}</span>
                  </div>
                )}
                
                {alert.estimatedResolution && (
                  <div className="flex items-center">
                    <Clock size={16} className="mr-1" />
                    <span className="font-medium mr-2">Résolution estimée:</span>
                    <span>{alert.estimatedResolution}</span>
                  </div>
                )}
              </div>
              
              {/* Contact d'urgence */}
              {alert.contact && (
                <div className="mt-4 pt-3 border-t border-current border-opacity-20">
                  <div className="flex items-center">
                    <PhoneCall size={16} className="mr-1" />
                    <span className="font-medium">Contact:</span>
                    <span className="ml-2">{alert.contact}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {onClose && (
            <button 
              className="text-current hover:bg-opacity-10 hover:bg-current rounded p-1"
              onClick={onClose}
              aria-label="Fermer l'alerte"
            >
              <X size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmergencyAlert;